'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './groupTransaction.routes.js';
import GrpTransactionListCtrl from './list/list.controller.js';
import GrpTransactionViewCtrl from './view/view.controller.js';
import GrpTransactionFormCtrl from './form/form.controller.js';

export default angular.module('georgeApp.groupTransaction',
  [uiRouter])
  .config(routing)
  .controller('GrpTransactionListCtrl', GrpTransactionListCtrl)
  .controller('GrpTransactionViewCtrl', GrpTransactionViewCtrl)
  .controller('GrpTransactionFormCtrl', GrpTransactionFormCtrl)
  .name;
